import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ theme, active }) =>
    active ? theme.primary.primary : theme.primary.lighter};
`;

const Dots = ({ currentDot, totalDots }) => {
  return (
    <Container>
      {Array.from({ length: totalDots }, (_, index) => (
        <Dot key={index} active={currentDot === index} />
      ))}
    </Container>
  );
};

export default Dots;
